import { net_filemanage } from "@/api/http";
export const API_STFMFM02C03_Initialize = (...params) =>
net_filemanage.post("/api/STFMFM02C03/Initialize", ...params)
export const API_STFMFM02C03_OpneFIlePreview = (...params) =>
net_filemanage.post("/api/STFMFM02C03/OpneFIlePreview", ...params)
export const API_STFMFM02C03_EditFolderPreview = (...params) =>
net_filemanage.post("/api/STFMFM02C03/EditFolderPreview", ...params)
export const API_STFMFM02C03_CheckFile= (...params) =>
net_filemanage.post("/api/STFMFM02C03/CheckFile", ...params)
export const API_STFMFM02C03_SearchFileList= (...params) =>
net_filemanage.post("/api/STFMFM02C03/SearchFileList", ...params)
export const API_STFMFM02C03_Download= (...params) =>
net_filemanage.post("/api/STFMFM02C03/Download", ...params)
export const API_STFMFM02C03_Export= (...params) =>
net_filemanage.post("/api/STFMFM02C03/Export", ...params)